import { CerrarPruebas } from "../controlSidebarCheckPruebas";
import { cerrarNuevaSalida } from "../controlSidebarDerecha";
import { CerrarDetalle } from "../controlSidebarDetalle";
import { CerrarEnRuta } from "../controlSidebarEnRuta";
import { CerrarRegresos } from "../controlSidebarRegresos";

export const cerrarTodo = () => {
  cerrarNuevaSalida();
  CerrarPruebas();
  CerrarDetalle();
};

export const cerrarEnRuta = () => {
  CerrarRegresos();
  CerrarEnRuta();
};
